import moment from 'moment';

export function convertDate(date, utcOffset = true) {
    if (utcOffset) {
        return moment(date).utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS');
    } else {
        return moment(date).subtract(7, 'hours').format('YYYY-MM-DD HH:mm:ss.SSS');
    }
}

export function convertDateNoTime(inputDate) {
    const date = moment(inputDate);
    date.hour(date.hour());

    const year = date.year();
    const month = String(date.month() + 1).padStart(2, '0');
    const day = String(date.date()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function convertDateFixTime(inputDate) {
    const date = moment(inputDate);
    date.hour(date.hour());

    const year = date.year();
    const month = String(date.month() + 1).padStart(2, '0');
    const day = String(date.date()).padStart(2, '0');

    return `${year}-${month}-${day} 00:00:00.000`;
}

export function formatDate(dateString) {
    if (dateString === null || dateString === '') {
        return null;
    }

    const date = new Date(dateString);
    date.setHours(date.getHours() - 7);

    const year = date.getFullYear() + 543;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
}

export function formatDateCheque(dateString) {
    if (dateString === null || dateString === '') {
        return null;
    }

    const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (datePattern.test(dateString)) {
        return dateString;
    }

    const date = new Date(dateString);
    if (isNaN(date)) {
        return null;
    }

    const year = date.getFullYear() + 543;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
}

export function formatDatetax(dateString) {
    if (dateString === null || dateString === '') {
        return null;
    }

    const date = new Date(dateString);

    const year = date.getFullYear() + 543;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
}

export function formatDateAndTime(dateString) {
    if (!dateString) {
        return null;
    }

    let date = new Date(dateString);
    date = new Date(date.getTime() - 7 * 60 * 60 * 1000);

    const year = date.getFullYear() + 543;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export function formatStringDateToDate(dateString) {
    if (!dateString || typeof dateString !== 'string') {
        return null;
    }

    const dateParts = dateString.split('-');
    if (dateParts.length !== 3) {
        return null;
    }

    const [day, month, buddhistYear] = dateParts;

    if (!day || !month || !buddhistYear || isNaN(day) || isNaN(month) || isNaN(buddhistYear)) {
        return null;
    }

    const christianYear = parseInt(buddhistYear, 10) - 543;

    if (isNaN(christianYear) || christianYear < 0) {
        return null;
    }

    const formattedDate = `${christianYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')} 00:00:00.000`;

    return formattedDate;
}

export function formatDateOnChange(dateString) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        throw new Error("Invalid date");
    }

    let year = date.getFullYear();
    if (year < 2500) {
        year += 543;
    }

    return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${year}`;
}

export function formatDateTime(date) {
    const padZero = (number, length) => number.toString().padStart(length, '0');

    const year = date.getFullYear().toString().slice(2);
    const month = padZero(date.getMonth() + 1, 2);
    const day = padZero(date.getDate(), 2);
    const hours = padZero(date.getHours(), 2);
    const minutes = padZero(date.getMinutes(), 2);
    const seconds = padZero(date.getSeconds(), 2);
    const milliseconds = padZero(date.getMilliseconds(), 3);

    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}

export function formatThaiDate(dateString) {
    if (dateString === null) {
        return null;
    }
    if (dateString === '') {
        return '';
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        throw new Error("Invalid date");
    }

    const year = date.getFullYear() + 543;

    return `${year}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
}

export function formatThaiDateUiToDate(date) {
    if (!date || typeof date !== 'string') {
        return null;
    }

    const [datePart, timePart] = date.split(' ');

    if (!datePart) {
        return null;
    }

    const [day, month, year] = datePart.split('-');

    if (!day || !month || !year) {
        return null;
    }

    const christianYear = Number(year) - 543;

    if (isNaN(christianYear) || christianYear < 0) {
        return null;
    }

    return timePart
        ? `${christianYear}-${month}-${day} ${timePart}`
        : `${christianYear}-${month}-${day} 00:00:00.000`;
}

export function getCurrentYearMonth() {
    const currentYear = (new Date().getFullYear() + 543).toString().slice(-2);
    const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');
    return { currentYear, currentMonth };
}

export function getCreateDateTime() {
    const today = new Date();
    const year = today.getFullYear() + 543;
    const day = today.getDate().toString().padStart(2, '0');
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const formattedNewDate = `${day}-${month}-${year}`;
    const formattedTime = today.toTimeString().split(' ')[0];
    return `${formattedNewDate} ${formattedTime}`;
}

export function setCreateDateTime(date) {
    if (date === null) {
        return null;
    }

    if (date === '') {
        return '';
    }

    const today = new Date(date);

    const year = today.getUTCFullYear() + 543;
    const day = today.getUTCDate().toString().padStart(2, '0');
    const month = (today.getUTCMonth() + 1).toString().padStart(2, '0');
    const formattedNewDate = `${day}-${month}-${year}`;

    const hours = today.getUTCHours().toString().padStart(2, '0');
    const minutes = today.getUTCMinutes().toString().padStart(2, '0');
    const seconds = today.getUTCSeconds().toString().padStart(2, '0');
    const formattedTime = `${hours}:${minutes}:${seconds}`;

    return `${formattedNewDate} ${formattedTime}`;
}